import { BASE_URL_API } from 'constants/base-url-default'
import { getCookie, removeCookie } from 'utils/functions-cookie'

import type { SharedTypes } from './get-profile'

export interface WalletCompany {
  name: string
  trading_name: string
  cnpj: string
  logo_url: string | null
  active: boolean
  share_type: SharedTypes
  default_share_value: number
  balance: number
  updated_at: string
  purchase_total: number
  reward_total: number
}

export const getWalletCompanyBalance = async () => {
  const authToken = getCookie('auth_token')

  if (!authToken) {
    throw new Error('Você não está autenticado.')
  }

  const response = await fetch(`${BASE_URL_API}/companies/wallet/balance`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${authToken}`,
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
    },
  })
  if (response.status === 401) {
    throw new Error('Sessão expirada')
  }

  if (response.status === 403) {
    removeCookie('auth_token')
    window.location.reload()
  }

  const { detail, ...userData } = (await response.json()) as WalletCompany & {
    detail?: string
  }

  if (response.status !== 200) {
    throw new Error(detail)
  }

  return userData
}
